//TABLE WITH 3 ROWS AND 6 COLUMNS (WPQ- BASE METAL TABLE)


import { isAlphanumericAllSpecialCharacters } from "../../../functions/validations";

import PropTypes from 'prop-types';
import { GenericTable } from "../../utility/common/TransactionComponents/GenericTable";
export const errorstatus = (error, columns, type) => {
  let status = false
  columns.map((column) => {
    if (column.field === 'ProductForm' || column.field === 'Spec' || column.field === 'Gno' || column.field === 'Thk' || column.field === 'Dia' || column.field === 'Pno') {

      console.log("error1222", error[`WPQ_BM_${type}_${column.field}`], `WPQ_BM_${type}_${column.field}`, error, error["WPQ_BM_BM_ProductForm"])
      if (error[`WPQ_BM_${type}_${column.field}`] && error[`WPQ_BM_${type}_${column.field}`].status) {
        status = true
      }
    }

  })
  return status
}

export const errormessage = (error, columns, type) => {
  let message = ""
  columns.map((column) => {
    if (column.field === 'ProductForm' || column.field === 'Spec' || column.field === 'Gno' || column.field === 'Thk' || column.field === 'Dia' || column.field === 'Pno') {
      if (error[`WPQ_BM_${type}_${column.field}`] && error[`WPQ_BM_${type}_${column.field}`].message) {
        message = error[`WPQ_BM_${type}_${column.field}`].message
      }
    }
  })

  return message

}
export const BaseMetalTable = ({
  headerObj,
  error,
  isReadonly,
  handleChange,
  setError,
  PNoActive,
  setheaderObj,
  errorstyle,
  blyestyle,
  disableFields,
  setIsEdited,
  isAllowDashedSpecialCharacters,
}) => {

  BaseMetalTable.propTypes = {
    headerObj: PropTypes.array,

    error: PropTypes.array,
    isReadonly: PropTypes.bool,
    setError: PropTypes.func,
    blyestyle: PropTypes.func,
    disableFields: PropTypes.bool,


    errorstyle: PropTypes.func,
    handleChange: PropTypes.func,
    PNoActive: PropTypes.array,

    setheaderObj: PropTypes.func
  }

  const columns = [
    {
      type: 'label',
      field: "label",
      width: '150px'

    },
    {
      header: 'Product Form',
      field: 'ProductForm',
      type: 'input',
      inputWidth: '152px',
      maxLength: 15,
      validator: isAllowDashedSpecialCharacters ? isAllowDashedSpecialCharacters : isAlphanumericAllSpecialCharacters,
      className: "WpsInput-md"
    },
    {
      header: 'Spec (type of Grade),UNS#',
      field: 'Spec',
      type: 'input',
      inputWidth: '250px',
      maxLength: 24,
      validator: isAllowDashedSpecialCharacters ? isAllowDashedSpecialCharacters : isAlphanumericAllSpecialCharacters,
      className: "WpsInput-md"
    },
    {
      header: 'P No. /A No.',
      field: 'Pno',
      type: 'dropdown',
      valueField: 'wld_code',
      labelField: 'wld_code',


    },
    {
      header: 'G No.',
      field: 'Gno',
      type: 'input',
      validator: isAlphanumericAllSpecialCharacters,
      maxLength: 4,
      className: "WpsInput-md"

    },

    {
      header: 'Thk.mm',
      field: 'Thk',
      type: 'input',
      validator: isAlphanumericAllSpecialCharacters,
      maxLength: 6,
      className: "WpsInput-md"
    },

    {
      header: 'Dia.mm',
      field: 'Dia',
      type: 'input',
      validator: isAlphanumericAllSpecialCharacters,
      maxLength: 6,
      className: "WpsInput-md"
    },


    // ... other columns
  ];

  // let tabledata = convertToRows(headerObj)

  const tableData = {
    rows: [
      {
        label: { value: 'Base Metal 1' },
        ProductForm: { value: headerObj?.WPQ_BM_BM_ProductForm, field: "WPQ_BM_BM_ProductForm", error: error["WPQ_BM_BM_ProductForm"]?.status || false },
        Spec: { value: headerObj?.WPQ_BM_BM_Spec, field: "WPQ_BM_BM_Spec", error: error["WPQ_BM_BM_Spec"]?.status || false },
        Pno: { value: headerObj?.WPQ_BM_BM_Pno, field: "WPQ_BM_BM_Pno", error: error["WPQ_BM_BM_Pno"]?.status || false },
        Gno: { value: headerObj?.WPQ_BM_BM_Gno, field: "WPQ_BM_BM_Gno", error: error["WPQ_BM_BM_Gno"]?.status || false },
        Thk: { value: headerObj?.WPQ_BM_BM_Thk, field: "WPQ_BM_BM_Thk", error: error["WPQ_BM_BM_Thk"]?.status || false },
        Dia: { value: headerObj?.WPQ_BM_BM_Dia, field: "WPQ_BM_BM_Dia", error: error["WPQ_BM_BM_Dia"]?.status || false },
        // ... other fields
        hasError: errorstatus(error, columns, "BM"),
        errorMessage: errormessage(error, columns, "BM")
      },
      {
        label: { value: 'Welded To - Base Metal 2' },
        ProductForm: { value: headerObj?.WPQ_BM_WTBM_ProductForm, field: "WPQ_BM_WTBM_ProductForm", error: error["WPQ_BM_WTBM_ProductForm"]?.status || false },
        Spec: { value: headerObj?.WPQ_BM_WTBM_Spec, field: "WPQ_BM_WTBM_Spec", error: error["WPQ_BM_WTBM_Spec"]?.status || false },
        Pno: { value: headerObj?.WPQ_BM_WTBM_Pno, field: "WPQ_BM_WTBM_Pno", error: error["WPQ_BM_WTBM_Pno"]?.status || false },
        Gno: { value: headerObj?.WPQ_BM_WTBM_Gno, field: "WPQ_BM_WTBM_Gno", error: error["WPQ_BM_WTBM_Gno"]?.status || false },
        Thk: { value: headerObj?.WPQ_BM_WTBM_Thk, field: "WPQ_BM_WTBM_Thk", error: error["WPQ_BM_WTBM_Thk"]?.status || false },
        Dia: { value: headerObj?.WPQ_BM_WTBM_Dia, field: "WPQ_BM_WTBM_Dia", error: error["WPQ_BM_WTBM_Dia"]?.status || false },
        // ... other fields
        hasError: errorstatus(error, columns, "WTBM"),
        errorMessage: errormessage(error, columns, "WTBM")
      },

      // ... other rows
    ]
  };

  const AdditionaRow = {
    rows: [{ value: headerObj?.wld_WPSType, header: "Joint Type", type: "text", colspan: 5 }]
  }
  console.log("tabledata", tableData)

  return (
    <GenericTable
      data={tableData}
      columns={columns}
      isReadonly={isReadonly}
      handleChange={handleChange}
      setError={setError}
      setData={setheaderObj}
      errorStyle={errorstyle}
      defaultStyle={blyestyle}
      disableFields={disableFields}
      AdditionalRow={AdditionaRow}
      dropdownData={{
        Pno: [PNoActive] // Your dropdown options here
      }}
      setIsEdited={setIsEdited}
      customColumnStyle={"border thead-color"}
    />
  )
};




export const BaseMetalTableTTS = ({
  headerObj,
  error,
  isReadonly,
  handleChange,
  setError,
  PNoActive,
  setheaderObj,
  errorstyle,
  blyestyle,
  disableFields,
  setIsEdited,
   isAllowDashedSpecialCharacters,
}) => {

  BaseMetalTableTTS.propTypes = {
    headerObj: PropTypes.array,
    error: PropTypes.array,
    isReadonly: PropTypes.bool,
    setError: PropTypes.func,
    blyestyle: PropTypes.func,
    disableFields: PropTypes.bool,
    errorstyle: PropTypes.func,
    handleChange: PropTypes.func,
    PNoActive: PropTypes.array,
    setheaderObj: PropTypes.func,
    setIsEdited: PropTypes.func
  }
  const columns = [
    {
      type: 'label',
      field: "label",
      width: '150px',
      className: "thickness_title"
    },
    {
      header: 'Product Form',
      field: 'ProductForm',
      type: 'input',
      inputWidth: '152px',
      maxLength: 16,
     validator: isAllowDashedSpecialCharacters ? isAllowDashedSpecialCharacters : isAlphanumericAllSpecialCharacters,
      className: "WpsInput-md"
    },
    {
      header: 'Spec (type of Grade),UNS#',
      field: 'Spec',
      type: 'input',
      inputWidth: '250px',
      maxLength: 25,
     validator: isAllowDashedSpecialCharacters ? isAllowDashedSpecialCharacters : isAlphanumericAllSpecialCharacters,
      className: "WpsInput-md"
    },
    {
      header: 'P No. /A No.',
      field: 'Pno',
      type: 'dropdown',
      valueField: 'wld_code',
      labelField: 'wld_code'

    },
    {
      header: 'G No.',
      field: 'Gno',
      type: 'input',
      validator: isAlphanumericAllSpecialCharacters,
      maxLength: 5,
      className: "WpsInput-md"

    },

    {
      header: 'Thk.mm',
      field: 'Thk',
      type: 'input',
      validator: isAlphanumericAllSpecialCharacters,
      maxLength: 6,
      className: "WpsInput-md"
    },

    {
      header: 'Dia.mm',
      field: 'Dia',
      type: 'input',
      validator: isAlphanumericAllSpecialCharacters,
      maxLength: 6,
      className: "WpsInput-md"
    },


    // ... other columns
  ];

  // let tabledata = convertToRows(headerObj)

  const tableData = {
    rows: [
      {
        label: { value: 'Base Metal 1' },
        ProductForm: { value: headerObj?.WPQ_BM_BM_ProductForm, field: "WPQ_BM_BM_ProductForm", error: error["WPQ_BM_BM_ProductForm"]?.status || false },
        Spec: { value: headerObj?.WPQ_BM_BM_Spec, field: "WPQ_BM_BM_Spec", error: error["WPQ_BM_BM_Spec"]?.status || false },
        Pno: { value: headerObj?.WPQ_BM_BM_Pno, field: "WPQ_BM_BM_Pno", error: error["WPQ_BM_BM_Pno"]?.status || false },
        Gno: { value: headerObj?.WPQ_BM_BM_Gno, field: "WPQ_BM_BM_Gno", error: error["WPQ_BM_BM_Gno"]?.status || false },
        Thk: { value: headerObj?.WPQ_BM_BM_Thk, field: "WPQ_BM_BM_Thk", error: error["WPQ_BM_BM_Thk"]?.status || false },
        Dia: { value: headerObj?.WPQ_BM_BM_Dia, field: "WPQ_BM_BM_Dia", error: error["WPQ_BM_BM_Dia"]?.status || false },
        // ... other fields
        hasError: errorstatus(error, columns, "BM"),
        errorMessage: errormessage(error, columns, "BM")
      },
      {
        label: { value: 'Welded To - Base Metal 2' },
        ProductForm: { value: headerObj?.WPQ_BM_WTBM_ProductForm, field: "WPQ_BM_WTBM_ProductForm", error: error["WPQ_BM_WTBM_ProductForm"]?.status || false },
        Spec: { value: headerObj?.WPQ_BM_WTBM_Spec, field: "WPQ_BM_WTBM_Spec", error: error["WPQ_BM_WTBM_Spec"]?.status || false },
        Pno: { value: headerObj?.WPQ_BM_WTBM_Pno, field: "WPQ_BM_WTBM_Pno", error: error["WPQ_BM_WTBM_Pno"]?.status || false },
        Gno: { value: headerObj?.WPQ_BM_WTBM_Gno, field: "WPQ_BM_WTBM_Gno", error: error["WPQ_BM_WTBM_Gno"]?.status || false },
        Thk: { value: headerObj?.WPQ_BM_WTBM_Thk, field: "WPQ_BM_WTBM_Thk", error: error["WPQ_BM_WTBM_Thk"]?.status || false },
        Dia: { value: headerObj?.WPQ_BM_WTBM_Dia, field: "WPQ_BM_WTBM_Dia", error: error["WPQ_BM_WTBM_Dia"]?.status || false },

        hasError: errorstatus(error, columns, "WTBM"),
        errorMessage: errormessage(error, columns, "WTBM")
      }
    ]
  };

  return (

    <GenericTable
      data={tableData}
      columns={columns}
      isReadonly={isReadonly}
      handleChange={handleChange}
      setError={setError}
      setData={setheaderObj}
      errorStyle={errorstyle}
      defaultStyle={blyestyle}
      disableFields={disableFields}
      dropdownData={{
        Pno: [PNoActive] // Your dropdown options here
      }}
      setIsEdited={setIsEdited}
    />
    /*     <Table className="text-center">
          <thead>
            <tr className="border thead-color ">
    
              <th className="thickness_title" style={{ width: "150px" }}></th>
              <th className="thickness_title  ">Product Form</th>
              <th className="thickness_title ">
                Spec (type of Grade),UNS#
              </th>
              <th
                className="thickness_title "
                style={{ width: "120px" }}
              >
                P No. /A No.
              </th>
              <th className="thickness_title  ">G No.</th>
              <th className="thickness_title ">Thk.mm</th>
              <th className="thickness_title ">Dia.mm</th>
            </tr>
          </thead>
    
          <tbody>
            <tr
              className={
                error.WPQ_BM_BM_ProductForm &&
                  (error.WPQ_BM_BM_ProductForm.status ||
                    error.WPQ_BM_BM_Spec.status ||
                    error.WPQ_BM_BM_Gno.status ||
                    error.WPQ_BM_BM_Thk.status ||
                    error.WPQ_BM_BM_Dia.status ||
                    error.WPQ_BM_BM_Pno.status)
                  ? "border error"
                  : "border"
              }
            >
              <th
                className={
                  error.WPQ_BM_BM_ProductForm &&
                    (error.WPQ_BM_BM_ProductForm.status ||
                      error.WPQ_BM_BM_Spec.status ||
                      error.WPQ_BM_BM_Gno.status ||
                      error.WPQ_BM_BM_Thk.status ||
                      error.WPQ_BM_BM_Dia.status ||
                      error.WPQ_BM_BM_Pno.status)
                    ? "text-start border thead-color error-head"
                    : "text-start border thead-color"
                }
              >
                <div>
                  <Form.Label>Base Metal 1</Form.Label>
                  {error.WPQ_BM_BM_ProductForm &&
                    (error.WPQ_BM_BM_ProductForm.status ||
                      error.WPQ_BM_BM_Spec.status ||
                      error.WPQ_BM_BM_Gno.status ||
                      error.WPQ_BM_BM_Thk.status ||
                      error.WPQ_BM_BM_Dia.status ||
                      error.WPQ_BM_BM_Pno.status) && (
                      <Tooltip
                        content={
                          error.WPQ_BM_BM_ProductForm.message ||
                          error.WPQ_BM_BM_Spec.message ||
                          error.WPQ_BM_BM_Gno.message ||
                          error.WPQ_BM_BM_Thk.message ||
                          error.WPQ_BM_BM_Dia.message ||
                          error.WPQ_BM_BM_Pno.message
                        }
                      >
                        <img src={Error} alt="Error" className="ms-1" />
                      </Tooltip>
                    )}
                </div>
              </th>
    
              <td className=" WpsInput-md">
                <input
                  id="WPQ_BM_BM_ProductForm"
                  style={{ height: "38px", width: "152px" }}
                  type="text"
                  className={
                    error.WPQ_BM_BM_ProductForm &&
                      error.WPQ_BM_BM_ProductForm.status
                      ? "error-input"
                      : ""
                  }
                  name={"WPQ_BM_BM_ProductForm"}
                  maxLength={headerObj.wld_WPSType === "Tubesheet" ? 15 : 16}
                  value={headerObj.WPQ_BM_BM_ProductForm}
                  readOnly={isReadonly}
                  disabled={disableFields}
                  onChange={handleChange}
                  onInput={(e) => {
                    let error = isAlphanumericAllSpecialCharacters(e.target.value);
                    setError((prevState) => ({
                      ...prevState,
                      WPQ_BM_BM_ProductForm: error,
                    }));
                  }}
                />
              </td>
    
              <td className="WpsInput-md">
                <input
                  id="WPQ_BM_BM_Spec"
                  type="text"
                  style={{ height: "38px", width: "250px" }}
                  className={
                    error.WPQ_BM_BM_Spec && error.WPQ_BM_BM_Spec.status
                      ? "error-input"
                      : ""
                  }
                  name={"WPQ_BM_BM_Spec"}
                  maxLength={headerObj.wld_WPSType === "Tubesheet" ? 35 : 25}
                  value={headerObj.WPQ_BM_BM_Spec}
                  readOnly={isReadonly}
                  disabled={disableFields}
                  onChange={handleChange}
                  onInput={(e) => {
            
                      let error = isAlphanumericAllSpecialCharacters(e.target.value);
                      setError((prevState) => ({
                        ...prevState,
                        WPQ_BM_BM_Spec: error,
                      }));
                    
                  }}
                />
              </td>
              <td className="WPSSelect">
                <SearchSelect
                  required
                  data={PNoActive}
                  stylegreen={error.WPQ_BM_BM_Pno.status ? errorstyle : blyestyle}
                  // disabled={isDisabled}
                  disabled={disableFields}
                  valueField={"wld_code"}
                  value={headerObj.WPQ_BM_BM_Pno}
                  labelField={"wld_code"}
                  placeholder=""
                  className={error.WPQ_BM_BM_Pno.status ? "error-input WPSSelect" : "WPSSelect"}
                  onChange={(pnoList) => {
                    setheaderObj((prev) => ({
                      ...prev,
                      WPQ_BM_BM_Pno: pnoList.value,
                    }));
                    setError((prevState) => ({
                      ...prevState,
                      WPQ_BM_BM_Pno: {},
                    }));
                  }}
                ></SearchSelect>
              </td>
              <td className="WpsInput-md ">
                <input
                  type="text"
                  style={{ height: "38px" }}
                  className={
                    error.WPQ_BM_BM_Gno && error.WPQ_BM_BM_Gno.status
                      ? "error-input"
                      : ""
                  }
                  name={"WPQ_BM_BM_Gno"}
                  maxLength={5}
                  value={headerObj.WPQ_BM_BM_Gno}
                  readOnly={isReadonly}
                  disabled={disableFields}
                  onChange={handleChange}
                  onInput={(e) => {
          
                      let error = isAlphanumericAllSpecialCharacters(e.target.value);
                      setError((prevState) => ({
                        ...prevState,
                        WPQ_BM_BM_Gno: error,
                      }));
                    }
                  
                  }
                />
              </td>
              <td className="WpsInput-md">
                <input
                  style={{ height: "38px" }}
                  type="text"
                  className={
                    error.WPQ_BM_BM_Thk && error.WPQ_BM_BM_Thk.status
                      ? "error-input"
                      : ""
                  }
                  name={"WPQ_BM_BM_Thk"}
                  maxLength={6}
                  value={headerObj.WPQ_BM_BM_Thk}
                  readOnly={isReadonly}
                  disabled={disableFields}
                  onChange={handleChange}
                  onInput={(e) => {
                  
                      let error = isAlphanumericAllSpecialCharacters(e.target.value);
                      setError((prevState) => ({
                        ...prevState,
                        WPQ_BM_BM_Thk: error,
                      }));
                    
                  }}
                />
              </td>
              <td className="WpsInput-md">
                <input
                  style={{ height: "38px" }}
                  type="text"
                  className={
                    error.WPQ_BM_BM_Dia && error.WPQ_BM_BM_Dia.status
                      ? "error-input"
                      : ""
                  }
                  name={"WPQ_BM_BM_Dia"}
                  maxLength={6}
                  value={headerObj.WPQ_BM_BM_Dia}
                  readOnly={isReadonly}
                  disabled={disableFields}
                  onChange={handleChange}
                  onInput={(e) => {
                  
                      let error = isAlphanumericAllSpecialCharacters(e.target.value);
                      setError((prevState) => ({
                        ...prevState,
                        WPQ_BM_BM_Dia: error,
                      }));
                    
                  }}
    
                />
              </td>
            </tr>
            <tr
              className={
                error.WPQ_BM_WTBM_ProductForm &&
                  (error.WPQ_BM_WTBM_ProductForm.status ||
                    error.WPQ_BM_WTBM_Spec.status ||
                    error.WPQ_BM_WTBM_Pno.status ||
                    error.WPQ_BM_WTBM_Gno.status ||
                    error.WPQ_BM_WTBM_Thk.status ||
                    error.WPQ_BM_WTBM_Dia.status)
                  ? "border  error"
                  : "border "
              }
            >
              <th
                className={
                  error.WPQ_BM_WTBM_ProductForm &&
                    (error.WPQ_BM_WTBM_ProductForm.status ||
                      error.WPQ_BM_WTBM_Spec.status ||
                      error.WPQ_BM_WTBM_Pno.status ||
                      error.WPQ_BM_WTBM_Gno.status ||
                      error.WPQ_BM_WTBM_Thk.status ||
                      error.WPQ_BM_WTBM_Dia.status)
                    ? "text-start  border thead-color error-head"
                    : "text-start border thead-color"
                }
              >
                <div>
                  Welded To - Base Metal 2
                  {error.WPQ_BM_WTBM_ProductForm &&
                    (error.WPQ_BM_WTBM_ProductForm.status ||
                      error.WPQ_BM_WTBM_Spec.status ||
                      error.WPQ_BM_WTBM_Pno.status ||
                      error.WPQ_BM_WTBM_Gno.status ||
                      error.WPQ_BM_WTBM_Thk.status ||
                      error.WPQ_BM_WTBM_Dia.status) && (
                      <Tooltip
                        content={
                          error.WPQ_BM_WTBM_ProductForm.status ||
                          error.WPQ_BM_WTBM_Spec.status ||
                          error.WPQ_BM_WTBM_Pno.status ||
                          error.WPQ_BM_WTBM_Gno.status ||
                          error.WPQ_BM_WTBM_Thk.status ||
                          error.WPQ_BM_WTBM_Dia.status
                        }
                      >
                        <img src={Error} alt="Error" className="ms-1" />
                      </Tooltip>
                    )}
                </div>
              </th>
              <td className="WpsInput-md">
                <input
                  style={{ height: "38px", width: "152px" }}
                  type="text"
                  className={
                    error.WPQ_BM_WTBM_ProductForm &&
                      error.WPQ_BM_WTBM_ProductForm.status
                      ? "error-input"
                      : ""
                  }
                  readOnly={isReadonly}
                  disabled={disableFields}
                  name={"WPQ_BM_WTBM_ProductForm"}
                  maxLength={15}
                  value={headerObj.WPQ_BM_WTBM_ProductForm}
                  onChange={handleChange}
                  onInput={(e) => {
                    let error = isAlphanumericAllSpecialCharacters(e.target.value);
                    setError((prevState) => ({
                      ...prevState,
                      WPQ_BM_WTBM_ProductForm: error,
                    }));
                  }}
                />
              </td>
              <td className="WpsInput-md">
                <input
                  style={{ height: "38px", width: "250px" }}
                  type="text"
                  className={
                    error.WPQ_BM_WTBM_Spec && error.WPQ_BM_WTBM_Spec.status
                      ? "error-input"
                      : ""
                  }
                  readOnly={isReadonly}
                  disabled={disableFields}
                  name={"WPQ_BM_WTBM_Spec"}
                  maxLength={35}
                  value={headerObj.WPQ_BM_WTBM_Spec}
                  onChange={handleChange}
                  onInput={(e) => {
                   
                      let error = isAlphanumericAllSpecialCharacters(e.target.value);
                      setError((prevState) => ({
                        ...prevState,
                        WPQ_BM_WTBM_Spec: error,
                      }));
                
                  }}
                />
              </td>
              <td className="WPSSelect">
                <SearchSelect
                  required
                  data={PNoActive}
                  stylegreen={error.WPQ_BM_WTBM_Pno.status ? errorstyle : blyestyle}
                  // disabled={isDisabled}
                  disabled={disableFields}
                  valueField={"wld_code"}
                  value={headerObj.WPQ_BM_WTBM_Pno}
                  labelField={"wld_code"}
                  placeholder=""
                  className={
                    error.WPQ_BM_WTBM_Pno.status
                      ? "err-input WPSSelect"
                      : "WPSSelect"
                  }
                  onChange={(pnoList) => {
                    setheaderObj((prev) => ({
                      ...prev,
                      WPQ_BM_WTBM_Pno: pnoList.value,
                    }));
                    setError((prevState) => ({
                      ...prevState,
                      WPQ_BM_WTBM_Pno: {},
                    }));
                  }}
                ></SearchSelect>
              </td>
              <td className="WpsInput-md">
                <input
                  style={{ height: "38px" }}
                  type="text"
                  className={
                    error.WPQ_BM_WTBM_Gno && error.WPQ_BM_WTBM_Gno.status
                      ? "error-input"
                      : ""
                  }
                  readOnly={isReadonly}
                  disabled={disableFields}
                  name={"WPQ_BM_WTBM_Gno"}
                  maxLength={ 5}
                  value={headerObj.WPQ_BM_WTBM_Gno}
                  onChange={handleChange}
                  onInput={(e) => {
                    let error = isAlphanumericAllSpecialCharacters(e.target.value);
                    setError((prevState) => ({
                      ...prevState,
                      WPQ_BM_WTBM_Gno: error,
                    }));
                  }}
                />
              </td>
              <td className="WpsInput-md">
                <input
                  style={{ height: "38px" }}
                  type="text"
                  className={
                    error.WPQ_BM_WTBM_Thk && error.WPQ_BM_WTBM_Thk.status
                      ? "error-input"
                      : ""
                  }
                  readOnly={isReadonly}
                  disabled={disableFields}
                  name={"WPQ_BM_WTBM_Thk"}
                  maxLength={6}
                  value={headerObj.WPQ_BM_WTBM_Thk}
                  onChange={handleChange}
                  onInput={(e) => {
                  
                      let error = isAlphanumericAllSpecialCharacters(e.target.value);
                      setError((prevState) => ({
                        ...prevState,
                        WPQ_BM_WTBM_Thk: error,
                      }));
                    
                  }}
                />
              </td>
              <td className="WpsInput-md">
                <input
                  style={{ height: "38px" }}
                  type="text"
                  className={
                    error.WPQ_BM_WTBM_Dia && error.WPQ_BM_WTBM_Dia.status
                      ? "error-input"
                      : ""
                  }
                  readOnly={isReadonly}
                  disabled={disableFields}
                  name={"WPQ_BM_WTBM_Dia"}
                  maxLength={6}
                  value={headerObj.WPQ_BM_WTBM_Dia}
                  onChange={handleChange}
                  onInput={(e) => {
                  
                      let error = isAlphanumericAllSpecialCharacters(e.target.value);
                      setError((prevState) => ({
                        ...prevState,
                        WPQ_BM_WTBM_Dia: error,
                      }));
                    
                  }}
                />
              </td>
            </tr>
          
          </tbody>
        </Table> 
      );*/
  )
};